import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { Headers, Http, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Constants } from "../../constants";
import { MatDialog } from "@angular/material";
import { ResultDialogComponent } from "../result-dialog/result-dialog.component";
import { Subscription } from "rxjs/Subscription";

import { CommercialService, LoadingService } from "@core/services";

import { fadeAnimation } from "../../app.animations";
import { BoundCallbackObservable } from "rxjs/observable/BoundCallbackObservable";
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.css"],
  animations: [fadeAnimation],
})
export class RegistrationComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("firstname") firstnameInput;

  registrationForm: FormGroup;
  errorMessage = "";
  isCommercial: any;
  subscription: Subscription;
  agreeTerms: boolean;
  agreeReferral: boolean;
  public rawPhone = "";
  public rawCellPhone = "";
  referralCode = "";

  constructor(
    private _http: Http,
    private _router: Router,
    private _loading: LoadingService,
    private dialog: MatDialog,
    private _commercial: CommercialService,
    private _formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  ngOnInit() {
    //get referral promo code
    this.activatedRoute.queryParams.subscribe(params => {
      this.referralCode = params['referralCode'] && params['referralCode'].length == 10 ? params['referralCode'] : undefined;
      console.log(this.referralCode);
    });

    this.registrationForm = this._formBuilder.group({
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      Email: ["", [Validators.required]],
      EmailConfirm: ["", [Validators.required]],
      BusinessName: [""],
      Address: ["", [Validators.required]],
      Address2: [""],
      City: ["", [Validators.required]],
      ProvinceState: ["", [Validators.required]],
      PostalCode: [
        "",
        [Validators.pattern("^[A-Za-z0-9s]{5,6}$"), Validators.required],
      ],
      TelephoneNumber: ["", [Validators.required, Validators.maxLength(15)]],
      CellNumber: ["", Validators.maxLength(15)],
      Password: ["", [Validators.minLength(8), Validators.required]],
      ConfirmPassword: ["", [Validators.minLength(8), Validators.required]],
      ReferralCode: [this.referralCode ? this.referralCode : "", [Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$"),]]
    });

    console.log(this.registrationForm);
    this.subscription = this._commercial
      .getCommercialValue()
      .subscribe((isCommercial) => {
        this.isCommercial = isCommercial;
      });

    //Add another field if has referral code
    // if (this.referralCode) {
    //   this.registrationForm.addControl("ReferralCode", new FormControl(this.referralCode,[Validators.minLength(10), Validators.maxLength(10)]));
    // }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.firstnameInput.nativeElement.focus();
  }

  onSubmit(): void {
    console.log(this.registrationForm);
    if (
      !this.confirmMatchEmails() ||
      !this.confirmMatchPasswords() ||
      !this.registrationForm.valid
    )
      return;

    this.recaptchaV3Service.execute('register').subscribe(
        (token: string) => {
    let formData: string;
    this._loading.showLoader();
    formData = JSON.stringify({
      ...this.registrationForm.value,
      recaptcha: token,
    });
    
    const registrationUrl = Constants.NEXPRESS_ENDPOINT + "Account/Register";
    const headers = new Headers({
      "Content-Type": "application/JSON",
    });
    const options = new RequestOptions({ headers: headers });
    this._http
      .post(registrationUrl, formData, options)
      .map((response) => response.json())
      .catch((error: any) => {
        this._loading.hideLoader();
        const mState = error.json().ModelState;
        let errorMessage = "";
        if (mState == null) {
          errorMessage = error.json().Message;
        } else {
          errorMessage = mState[Object.keys(mState)[0]];
        }
        return Observable.throw(errorMessage || "Server error");
      })
      .subscribe(
        (result) => {
          //Add referral code to local storage
          if (this.registrationForm.controls.ReferralCode.value) {
            localStorage.setItem('referralCode', this.registrationForm.controls.ReferralCode.value);
          }
          setTimeout(() => {
            this._router.navigateByUrl("/checkemail");
            this.errorMessage = "";
            this._loading.hideLoader();
          }, 1000)
        },
        (error) => {
          if(error && error.toString().includes('is already taken')) {
            error = error + " If this account belongs to you please try to login or reset your password."
          }
          let dialogRef = this.dialog.open(ResultDialogComponent, {
            data: {
              message: error,
              alertType: "danger",
              title: "Failed to create account",
            },
          });
          this.errorMessage = error;
          this._loading.hideLoader();
        },
        () => {
          this._loading.hideLoader();
          if (this.registrationForm.controls.ReferralCode.value) {
            localStorage.setItem('referralCode', this.registrationForm.controls.ReferralCode.value);
          }
        }
      );
      if (this.registrationForm.controls.ReferralCode.value) {
        localStorage.setItem('referralCode', this.registrationForm.controls.ReferralCode.value);
      }
    });
  }

  formatPostaZip() {
    let value = this.registrationForm.controls.PostalCode.value;
    if (value.length > 6)
      this.registrationForm.controls.PostalCode.setValue(
        value.replace(/\s/g, "")
      );
  }

  // TODO: Create custom Validator for this.
  private confirmMatchPasswords() {
    let password: string = String(
      this.registrationForm.controls.Password.value
    ).toString();
    let confirm: string = String(
      this.registrationForm.controls.ConfirmPassword.value
    ).toString();
    return password === confirm;
  }

  // TODO: Create custom Validator for this.
  private confirmMatchEmails() {
    let email: string = String(
      this.registrationForm.controls.Email.value
    ).toString();
    let confirm: string = String(
      this.registrationForm.controls.EmailConfirm.value
    ).toString();
    return email === confirm;
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/registration/registration.component.ts